// src/components/KhoiChiTieu.js
import React, { useState } from "react";
import { veTien, veSo, veTenThang } from "../utils/tien";
import XemAnh from "./XemAnh";

// ============================================================
// 💰 KHỐI BÁO CHI TIÊU — dùng chung cho Bảng tin và trang Chi tiêu
// ------------------------------------------------------------
// Đây chính là cái khung vẽ trong tài liệu chân dung mục 4.3:
//
//   💰 Chi tiêu tháng 9
//      Tiền điện        1.400.000 đ
//      Học phí          3.000.000 đ
//      Chợ búa          5.200.000 đ
//      ─────────────────────────────
//      Tổng             9.600.000 đ   ↑ tăng 800.000 so với tháng 8
//
//      💬 "Tháng này điện tăng nhiều. Cả nhà nhớ tắt máy lạnh nhé." — Ba
//
// ⚠️ BA ĐIỀU ĐỪNG ĐỔI:
//
// 1. DÒNG SO SÁNH THÁNG TRƯỚC là lý do mục này tồn tại. Zalo có ảnh hóa
//    đơn, Zalo có lời nhắn — Zalo KHÔNG có dòng này. "Tăng 800 nghìn" tác
//    động mạnh hơn tấm ảnh, vì nó nói XU HƯỚNG chứ không nói con số lẻ.
//
// 2. KHÔNG tô đỏ chữ khi tăng, không tô xanh khi giảm như app tài chính.
//    Chân dung mục 5.1: app TRÌNH BÀY SỰ THẬT, app KHÔNG PHẠT. Màu đỏ là
//    một lời phán xét. Dùng mũi tên và chữ, để người đọc tự thấy.
//
// 3. LỜI NHẮN nằm NGAY CẠNH con số, không phải ở chỗ khác. Đó là điểm
//    khác biệt với Zalo: ở Zalo lời kêu gọi tiết kiệm trôi mất sau vài
//    chục tin nhắn, ở đây nó dính liền với con số và ở lại.
//
// Tham số `gonGang` = true khi đặt trên Bảng tin: chỉ ĐỌC, không nút nào.
// ============================================================

// ============================================================
// 📎 ẢNH HOÁ ĐƠN THEO TỪNG KHOẢN (Đợt N5, anh chốt 14/09 — câu 2)
// ------------------------------------------------------------
// Khoản có ảnh → nút 📎 cạnh số tiền, bấm là mở ảnh to hết màn hình.
// Ảnh đã dọn khỏi VPS → chữ "🗂️ ảnh đã cất" (số tiền, lời nhắn vẫn còn).
// Cả nhà ai xem được bản tin thì xem được ảnh; gắn ảnh thì ở trang Báo chi
// tiêu, chỉ người soạn (Ba Mẹ) thấy nút.
// ============================================================
function KhoiChiTieu({ thang, gonGang }) {
  const [dangXem, setDangXem] = useState(null); // khoản đang mở ảnh
  if (!thang) return null;

  const cl = thang.chenh_lech;
  const coSoSanh = cl !== null && cl !== undefined;

  return (
    <div className={`ct-khoi ${gonGang ? "ct-khoi-gon" : ""}`}>
      <h4 className="ct-tieu-de">💰 Chi tiêu {veTenThang(thang.thang_ma).toLowerCase()}</h4>

      {thang.khoan.length === 0 ? (
        <p className="ct-chua-co">Chưa có khoản nào trong tháng này.</p>
      ) : (
        <table className="ct-bang">
          <tbody>
            {thang.khoan.map((k) => (
              <tr key={k.id}>
                <td className="ct-ten-khoan">{k.ten}</td>
                <td className="ct-anh-khoan">
                  {k.anh_id && !k.anh_da_don && (
                    <button
                      className="ct-nut-kep"
                      onClick={() => setDangXem(k)}
                      title={`Xem ảnh hoá đơn ${k.ten}`}
                      aria-label={`Xem ảnh hoá đơn ${k.ten}`}
                    >
                      📎
                    </button>
                  )}
                  {k.anh_id && k.anh_da_don && (
                    <span className="anh-da-cat" title="Ảnh đã tải về máy chủ nhà rồi dọn khỏi VPS">
                      🗂️ ảnh đã cất
                    </span>
                  )}
                </td>
                <td className="ct-so-tien">{veTien(k.so_tien)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="ct-dong-tong">
              {/* colSpan 2: bảng có thêm cột 📎 giữa tên và số tiền (N5) */}
              <td colSpan={2}>Tổng</td>
              <td className="ct-so-tien">{veTien(thang.tong)}</td>
            </tr>
          </tfoot>
        </table>
      )}

      {/* Dòng so sánh. Không có bản tin tháng liền trước thì KHÔNG hiện gì
          cả — nói "so với tháng trước" trong khi lấy số của tháng 5 là nói
          sai sự thật. */}
      {coSoSanh && (
        <p className="ct-so-sanh">
          {cl > 0 && `↑ tăng ${veSo(cl)} đ so với tháng ${thang.thang_truoc_hien}`}
          {cl < 0 && `↓ giảm ${veSo(-cl)} đ so với tháng ${thang.thang_truoc_hien}`}
          {cl === 0 && `bằng đúng tháng ${thang.thang_truoc_hien}`}
        </p>
      )}

      {/* Tháng trước CÓ bản tin nhưng chưa nhập khoản nào thì KHÔNG so sánh.
          Lấy 0 làm mốc sẽ ra "tăng bằng đúng cả tổng tháng này" — nghe như
          nhà tiêu thêm chừng đó, trong khi sự thật là tháng trước chưa ai
          nhập gì. Nói rõ chuyện đó ra thay vì lặng lẽ bỏ dòng so sánh: bỏ
          lặng lẽ thì người ta lại tưởng app hỏng. */}
      {!coSoSanh && thang.thang_truoc_chua_nhap && (
        <p className="ct-chua-so-sanh">
          Chưa so sánh được — tháng {thang.thang_truoc_hien} chưa nhập khoản nào.
        </p>
      )}

      {thang.loi_nhan && (
        <div className="ct-loi-nhan">
          <span className="ct-loi-nhan-chu">💬 “{thang.loi_nhan}”</span>
          {thang.ten_nguoi_dang && (
            <span className="ct-nguoi-dang"> — {thang.ten_nguoi_dang}</span>
          )}
        </div>
      )}

      {dangXem && (
        <XemAnh
          anhId={dangXem.anh_id}
          tieuDe={`${dangXem.ten} · ${veTenThang(thang.thang_ma).toLowerCase()}`}
          onDong={() => setDangXem(null)}
        />
      )}
    </div>
  );
}

export default KhoiChiTieu;
